/* eslint-disable import/prefer-default-export */
export const canUpdateBlockContract = ({ permissions }) =>
  permissions.includes('parametrizacao.bloqueiocontrato.write');

export const shouldBlockUnsignedContract = (cooperator, payrollConfig) => {
  const { hasSignedContract, accessionDate } = cooperator;
  const { REACT_APP_MANDATORY_SIGNING_OF_THE_CONTRACT_IN } = process.env;
  const deadLineToSigning =
    REACT_APP_MANDATORY_SIGNING_OF_THE_CONTRACT_IN && accessionDate > REACT_APP_MANDATORY_SIGNING_OF_THE_CONTRACT_IN;
  return !hasSignedContract && deadLineToSigning && payrollConfig?.bloquear_coop_sem_contrato;
};
